import { Span } from '../Reusables/Typography/P'
import Image from 'next/image';
import LargerHeading from './LargerHeading';

const BulletSpan = ({number, text}) => {
    return (
        <div className="mt-2 mb-2">
            <Span className="text-vertical">
                <Image
                    style={{
                        objectFit: "cover",
                        height: "1.5em", 
                        width:  "1.5em", 
                        verticalAlign: "middle"
                    }}
                    height={25}
                    width={25}
                    src={`/images/${process.env.brand.acronym}/eh-bulletpoint.png`}
                    quality={75}
                    priority
                    sizes="(max-width: 768px) 5vw, 33vw"
                    alt="icon"
                />
                <Span className="ml-2">
                    <LargerHeading>
                        {text}
                    </LargerHeading>
                </Span>
            </Span>
        </div>
    )

}

export default BulletSpan